import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDSelect from "@mui/material/Select";
import MDOption from "@mui/material/MenuItem";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import useBiometricData from "layouts/tables/data/biometricTableData";
import CircularProgress from "@mui/material/CircularProgress";

function Biometric() {
  const {
    columns,
    rows,
    isLoading,
    error,
    registrationModalOpen,
    setRegistrationModalOpen,
    selectedMember,
    fingerIndex,
    setFingerIndex,
    isProcessing,
    registerFingerprint,
  } = useBiometricData();

  const FINGER_OPTIONS = [
    { value: 0, label: "Left Thumb" },
    { value: 1, label: "Left Index" },
    { value: 2, label: "Left Middle" },
    { value: 3, label: "Left Ring" },
    { value: 4, label: "Left Pinky" },
    { value: 5, label: "Right Thumb" },
    { value: 6, label: "Right Index" },
    { value: 7, label: "Right Middle" },
    { value: 8, label: "Right Ring" },
    { value: 9, label: "Right Pinky" },
  ];

  if (isLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <MDTypography>Loading Biometrics...</MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <MDTypography color="error">Error: {error}</MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid container alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <MDTypography variant="h6" color="white">
                      Member Biometric Registration
                    </MDTypography>
                  </Grid>
                  <Grid item>
                    <MDButton variant="gradient" color="dark">
                      <Icon>refresh</Icon>&nbsp;Refresh
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  searchLabel="Search Members..."
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Fingerprint Registration Modal */}
      {/* Fingerprint Registration Modal */}
      <Dialog
        open={registrationModalOpen}
        onClose={() => setRegistrationModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <MDBox p={3}>
          <MDTypography variant="h5" gutterBottom>
            Register Fingerprint for{" "}
            {selectedMember
              ? selectedMember.first_name && selectedMember.surname
                ? `${selectedMember.first_name} ${selectedMember.surname}`
                : selectedMember.memberName || "Selected Member"
              : "Selected Member"}
          </MDTypography>

          <MDBox mb={3}>
            <MDTypography variant="body2" color="textSecondary">
              Please select the finger to register and place it on the scanner when prompted.
            </MDTypography>
          </MDBox>

          <MDSelect
            label="Select Finger"
            value={fingerIndex}
            onChange={(e) => setFingerIndex(Number(e.target.value))}
            fullWidth
            margin="normal"
          >
            {FINGER_OPTIONS.map((finger) => (
              <MDOption key={finger.value} value={finger.value}>
                {finger.label}
              </MDOption>
            ))}
          </MDSelect>

          <MDBox mt={3} display="flex" justifyContent="flex-end">
            <MDButton
              variant="gradient"
              color="secondary"
              onClick={() => setRegistrationModalOpen(false)}
              mr={2}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              onClick={registerFingerprint}
              disabled={isProcessing}
            >
              {isProcessing ? (
                <>
                  <CircularProgress size={20} color="inherit" /> &nbsp; Processing...
                </>
              ) : (
                "Enroll Fingerprint"
              )}
            </MDButton>
          </MDBox>
        </MDBox>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

Biometric.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  registrationModalOpen: PropTypes.bool,
  setRegistrationModalOpen: PropTypes.func,
  selectedMember: PropTypes.object,
  fingerIndex: PropTypes.number,
  setFingerIndex: PropTypes.func,
  isProcessing: PropTypes.bool,
  registerFingerprint: PropTypes.func,
};

export default Biometric;
